export const environment = {
  production: false,
  development: false,
  apiUrl: 'https://tiendapp-backend-staging-dpe4h5dkaracbned.brazilsouth-01.azurewebsites.net/api' // URL base para la API en staging
};